module.exports = __webpack_public_path__ + "static/media/Artboard7.6110cdc9.png";